import { ActionButton, AltButton } from '../../common/Buttons/Buttons';
import { Input } from '../../common/Forms/Input/Input';

export const VehicleBrandFormPanel = ({
  editingVehicleBrandId,
  vehicleClassOptionsList,
  register,
  errors,
  onSubmit,
  onCancel,
}) => (
  <>
    <h4 className="parameters-page__create-title">
      {editingVehicleBrandId
        ? 'Editar marca de vehículo'
        : 'Crear nueva marca de vehículo'}
    </h4>
    <div className="parameters-page__create-fields parameters-page__create-fields--city">
      <div
        className="row"
        style={{ width: '100%', alignItems: 'flex-start' }}
      >
        {!editingVehicleBrandId && (
          <Input
            bootstrap="col-12 col-md-3"
            label="Clase de vehículo *"
            type="select"
            name="classId"
            options={vehicleClassOptionsList}
            register={register}
            placeholder=""
            errors={errors?.classId?.message}
          />
        )}
        <Input
          bootstrap="col-12 col-md-3"
          label="Nombre de la marca *"
          type="text"
          name="brandName"
          register={register}
          placeholder="Ej: Toyota, Ford, etc."
          errors={errors?.brandName?.message}
        />
        <div
          className="col-12 col-md-auto buttons-center-container"
          style={{ marginTop: '32px' }}
        >
          <ActionButton
            label={editingVehicleBrandId ? 'Guardar cambios' : 'Guardar'}
            action={onSubmit}
          />
          <AltButton label="Cancelar" action={onCancel} />
        </div>
      </div>
    </div>
  </>
);
